module.exports = __webpack_public_path__ + "media/images/screenshots/results-deba2f5f6ad50df6ed12851b1304d2cb.png";